export default __webpack_public_path__ + "static/media/R_Rato.919c9d46.svg";